import React, { useMemo } from "react";
import { Loandetails } from "./style";
import { sumData } from "utils";
// import EmptyDataUi from "components/EmptyDoc"
// import SendMemoComp from "components/Dashboard/Loan/SendMemoComp"
import { useState } from "react";
import Tabledetails from "./LoanDetailstable";
import { CheckBox } from "components/Checkbox";
import { notification, Table } from "antd";
import { MEMO_COLUMNS_V2 } from "components/Dashboard/Loan/RefferedLoans/appColumns";
import DownloadCSVBtn from "components/Dashboard/Loan/AcctAcceptedLoans/DownloadCsvBtn";
import { updateMemoLoans } from "services/AdminUserService";
import { useParams } from "react-router-dom";

function LoanAppTable({
  tableData,
  title = "",
  role,
  selectedLoans,
  selectLoan,
  refetch
}) {

  const [searchQuery, setSearchQuery] = useState("");
  const [loading,setLoading] = useState(false)

  const {id:memo_id} = useParams()

  const handleUpdateLoans = async ()=>{
	setLoading(true)
	try {
		const res = await updateMemoLoans({
			memo_id,
			selectedLoans
		})
		if(res.error){
			throw new Error(res.message)
		}
		refetch()
	} catch (error) {
		notification.error({
			message:"Upload Memo Loan Error",
			description:error?.message ?? "An error occurred could not update memo loans"
		})
	}finally{
		setLoading(false)
	}
  }

  const filteredLoan = useMemo(() => {
    return tableData
      .filter((loan) => !loan.esLoans)
      .filter((item) => {
        if (!searchQuery) return true;
        const searchValue = `${item.applicant.surname} ${item.applicant.first_name} ${item.applicant.middle_name} ${item.applicant.lga} ${item.institution.name}`;
        return searchValue
          .toLowerCase()
          .includes(searchQuery.trim().toLowerCase());
      });
  }, [tableData, searchQuery]);

  const [show, setShow] = useState(false);
  const [selected, setSelected] = useState({});

  // const showDetails = payload => {
  // 	setShow(true)
  // 	setSelected(payload)
  // }
  const closeDetails = () => {
    setShow(false);
    setSelected({});
  };
  const totalAmountApproved =
    tableData?.length > 0 ? tableData?.map((data) => data?.amount) : [0];
  const amountTotal = sumData(totalAmountApproved);

  return (
    <>
      {show && (
        <Loandetails show={show}>
          <Tabledetails payload={selected} close={closeDetails} />
        </Loandetails>
      )}
      <div>
        <div>
          <div className="justify-between my-2 flex items-center">
            <h5 className="font-bold">{title}</h5>
            <header
              className={`flex bg-white flex-1 items-center max-w-[400px] gap-x-2 py-3 ${
                filteredLoan.length > 0 ? "mx-auto" : "ml-auto"
              } border border-gray-300 rounded-lg p-2`}
            >
              <i className="bi bi-search"></i>
              <input
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="flex-1 w-full outline-0"
                placeholder="Search by name, lga or institution"
              />
              <button>
                <i className="bi bi-x-lg"></i>
              </button>
            </header>
            {filteredLoan?.length > 0 ? (
              <div className="ml-auto">
                {role === "lph" && (
                  <div className="flex items-center gap-x-4">
                    <DownloadCSVBtn
                      data={tableData}
                      showStatus={false}
                      fileName="memo"
                    />
                    <button onClick={handleUpdateLoans} disabled={loading} className="px-4 py-2 disabled:opacity-45 bg-primary text-white rounded-lg">
						{loading
						?<span>Updating Loans...</span>
						:<span>Update Loans</span>
						}
					</button>
                  </div>
                )}
              </div>
            ) : null}
            <span style={{ marginLeft: "10px" }}></span>
          </div>
        </div>
        <div>
          <Table
            columns={[
              {
                title: "Pick",
                fixed: "left",
                key: "pick",
                width: 100,
                render: (_, loan) => (
                  <CheckBox
                    checked={selectedLoans.includes(loan._id)}
                    handleCheck={() => selectLoan(loan._id)}
                  />
                ),
              },
              ...MEMO_COLUMNS_V2,
            ]}
            footer={() => {
              return (
                <div className="font-medium">
                  <b>Total Loan Amount : </b>₦{amountTotal.toLocaleString()}
                </div>
              );
            }}
            scroll={{ x: 1300 }}
            dataSource={filteredLoan}
          />
        </div>
      </div>
    </>
  );
}

export default LoanAppTable;
